import { Component } from '@angular/core';
@Component({
  selector: 'fgb-tickets-page',
  templateUrl: './tickets-page.component.html',
  styleUrls: ['./tickets-page.component.scss'],
})
export class TicketsPageComponent {}
